import { useStandardApiHandler } from '@gettactic/helpers';
import React from 'react';
import { IconDictionaries } from '../../controls';

const StoreIconDictionariesName = 'DashboardIconDictionaries' as const;

export const useIconDictionaries = () => {
  const [iconDictionaries, setIconDictionaries] = React.useState<
    IconDictionaries | undefined
  >(window[StoreIconDictionariesName as never] as never);

  const { wrapApiRequest } = useStandardApiHandler();

  const loadDictionaries = wrapApiRequest(async () => {
    const dictionaries = (await import('../icons-dictionary'))
      .iconsDictionary as IconDictionaries;

    (window[StoreIconDictionariesName as never] as unknown) = dictionaries;
    setIconDictionaries(dictionaries);
  });

  const hasDictionary = iconDictionaries !== undefined;

  React.useEffect(() => {
    if (iconDictionaries !== undefined) return;

    loadDictionaries().then();
  }, [hasDictionary]);

  return iconDictionaries;
};
